import useDidMount from '../../../hooks/useDidMount';
import { BaseRootStore } from '../../rootStore/baseRootStore';

export default function useCountries(rootStore: BaseRootStore) {
  const { countriesStore } = rootStore;

  useDidMount(() => {
    void countriesStore.fetchCountriesList();
  });

  return {
    alpha2List: countriesStore.countriesAlpha2List,
    trialAvailableAlpha3List: countriesStore.countriesTrialAvailableAlpha3List,
    loaded: countriesStore.loaded,
  };
}
